import React from 'react';
import Slider from "react-slick";
import leftIcon from 'src/assets/images/product-slider-left-icon.png';
import rightIcon from 'src/assets/images/product-slider-right-icon.png';
import { IPharmacyObj } from 'src/types/GlobalInterfaces';
import { Link } from 'react-router-dom';
import AddCartComponent from '../Customer/ProductsAndServicesComponents/AddCartComponent';
import IsFavoriteComponent from '../Customer/ProductsAndServicesComponents/IsFavoriteComponent';
import { truncateString } from 'src/helpers/helperFunctions';
import { CURRENCY } from 'src/lib/constans';

interface IProps {
    loader: boolean;
    data: IPharmacyObj[];
    setUpdatedData: React.Dispatch<React.SetStateAction<IPharmacyObj[]>>;  // Set type for setProducts 
};

const MyAsterSlider: React.FC<IProps> = ({
    loader = false,
    data = [],
    setUpdatedData
}) => {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        // autoplay: true,
        // autoplaySpeed: 8000,
        draggable: false,
        swipe: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
        prevArrow: <div>
            <div className='my-asster-slider-arrow-btn'>
                <img src={leftIcon} alt='' />
            </div>
        </div>
        ,
        nextArrow:
            <div>
                <div className='my-asster-slider-arrow-btn'>
                    <img src={rightIcon} alt='' />
                </div>
            </div>
        ,
    };

    const handleIsLikeChanged = (obj: { productId: string; isLiked: boolean }) => {
        const { productId = "", isLiked = false } = obj;
        setUpdatedData(prev => prev?.map(v => (v._id === productId ? { ...v, isLiked } : v)));
    };
    return (
        <div className='my-aster-slider my-aster-slider-arrows-issue'>
            {data?.length > 6 ?
                <Slider {...settings}>
                    {data?.map(item => (
                        <div key={item?._id} className="pharmacy-card-main card-wdith-issue-resolve">
                            <div className='Prescription-requird-main'>
                                <div className='Prescription-requird'>
                                    {item?.prescriptionRequired ?
                                        <span className='Prescription-requird-inner-span text-white font-Poppins-Regular font-size-12px'>Prescription Required</span>
                                        :
                                        <span></span>
                                    }
                                    <IsFavoriteComponent
                                        productId={item?._id}
                                        isFav={item?.isLiked || false}
                                        category="pharmacy"
                                        onSuccess={handleIsLikeChanged}
                                    />
                                </div>
                            </div>
                            <div className='pharmacy-card-main-content-cls-inner'>
                                <img
                                    className='product-dummy-img'
                                    src={`${item?.mainImage}`}
                                    alt={""}
                                />
                            </div>
                            <div className='pharmacy-card-main-content-cls'>
                                <Link to={`/pharmacy-products/${item?._id}/view`}>
                                    <p className='font-size-14px font-Poppins-SemiBold pharmacy-card-main-span-title theme-color-green'>{truncateString(item?.productName || "", 40)}</p>
                                </Link>
                                <div className='flex product-item-card-price justify-between'>
                                    <div className='sale-price-or-regular-price'>
                                        <strong className='font-size-18px font-Poppins-Bold theme-color-green'>{CURRENCY} {item?.salePrice || item?.regularPrice}</strong>
                                        {item?.salePrice != null && item?.salePrice > 0 && (
                                           <strong className='font-size-13px line-through font-Poppins-Regular text-[#878787]'>{CURRENCY} {`${item?.regularPrice || "-"}`}</strong>
                                        )}
                                    </div>
                                    <AddCartComponent
                                        productId={item?._id}
                                        type="pharmacy"
                                        prescriptionRequired={item?.prescriptionRequired || false}
                                        quantity={1}
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
                :
                <div className='slider-my-aster-issue'>
                    {data?.map(item => (
                        <div key={item?._id} className="pharmacy-card-main card-wdith-issue-resolve">
                            <div className='Prescription-requird-main'>
                                <div className='Prescription-requird'>
                                    {item?.prescriptionRequired ?
                                        <span className='Prescription-requird-inner-span text-white font-Poppins-Regular font-size-12px'>Prescription Required</span>
                                        :
                                        <span></span>
                                    }
                                    <IsFavoriteComponent
                                        productId={item?._id}
                                        isFav={item?.isLiked || false}
                                        category="pharmacy"
                                        onSuccess={handleIsLikeChanged}
                                    />
                                </div>
                            </div>
                            <div className='pharmacy-card-main-content-cls-inner'>
                                <img
                                    className='product-dummy-img'
                                    src={`${item?.mainImage}`}
                                    alt={""}
                                />
                            </div>
                            <div className='pharmacy-card-main-content-cls'>
                                <Link to={`/pharmacy-products/${item?._id}/view`}>
                                    <p className='font-size-14px font-Poppins-SemiBold pharmacy-card-main-span-title theme-color-green'>{truncateString(item?.productName || "", 40)}</p>
                                </Link>
                                <div className='flex product-item-card-price justify-between'>
                                    <div className='sale-price-or-regular-price'>
                                        <strong className='font-size-18px font-Poppins-Bold theme-color-green'>{CURRENCY} {item?.salePrice || item?.regularPrice}</strong>
                                        {item?.salePrice != null && item?.salePrice > 0 && (
                                        <strong className='font-size-13px line-through font-Poppins-Regular text-[#878787]'>{CURRENCY} {`${item?.regularPrice || "-"}`}</strong>
                                        )}
                                    </div>
                                    <AddCartComponent
                                        productId={item?._id}
                                        type="pharmacy"
                                        prescriptionRequired={item?.prescriptionRequired || false}
                                        quantity={1}
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            }
        </div>
    );
};

export default MyAsterSlider;